
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { UserInfo } from "../../models/dossier/user-info";
import { Folder } from "../../models/tasks/folder";
import { DossierService } from "../../services/dossier-service";
import { TaskService } from "../../services/task-service";
import AppUserSearch from "../UserSearch.vue";

export default FormLike.extend({
	data() {
		return {
			newName: "",
			allUsers: [] as UserInfo[],
		};
	},
	props: {
		value: Boolean,
		folder: {
			type: Object as () => Folder,
		}
	},
	computed: {
		sharedUsers(): UserInfo[] {
			if (!this.folder) {
				return [];
			}
			return this.folder.FolderUsers.map(f => this.allUsers.find(u => u.ID == f.UserID)).filter(f => f != null) as UserInfo[];
		},
		notAddedUsers(): UserInfo[] {
			if (!this.folder) {
				return [];
			}
			return this.allUsers.filter(u => this.folder.FolderUsers.find(f => f.UserID == u.ID) == null);
		}
	},
	methods: {
		async submit() {
			this.validate();
			if (!this.isValid) return;
			let result = await TaskService.renameFolder(this.folder, this.newName);
			this.$emit("update:folder", result);
			this.close();
		},
		async removeUser(user: UserInfo) {
			let folder = await TaskService.removeUserFromFolder(this.folder, [user.ID]);
			this.$emit("update:folder", folder);
		},
		async addUser(user: UserInfo) {
			let folder = await TaskService.addUsersToFolder(this.folder, [user.ID]);
			this.$emit("update:folder", folder);
		},
		async addAllUsers() {
			let folder = await TaskService.addUsersToFolder(this.folder, this.notAddedUsers.map(u => u.ID));
			this.$emit("update:folder", folder);
		},
		close() {
			this.$emit("close");
		},
	},
	async mounted() {
		if (this.folder)
			this.newName = this.folder.Name;
	},
	async created() {
		this.allUsers = await DossierService.getUsers();
	},
	components: {
		AppUserSearch
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
